import PropTypes from 'prop-types'
import { Base64 } from 'js-base64'
import { useRouter } from 'next/router'
import { useEffect, useState } from 'react'
import * as Cookies from 'js-cookie'

import { getAppRoute } from 'helpers/application'
import withSignUp from 'hocs/withSignUp'

import SignUp from './Screen'

const SignUpHOC = Component => {
  const Wrapper = props => {
    const router = useRouter()
    const [queryData, setQueryData] = useState(null)
    const [isLoading, setIsLoading] = useState(true)

    useEffect(() => {
      if (!router.isReady) return

      const clientSideInit = async () => {
        const { redirectTo, application, signup_data } = router.query
        const accessToken = Cookies.get('citifyd_access_token')

        let parsedQueryData = null

        if (signup_data) {
          parsedQueryData = JSON.parse(Base64.decode(signup_data))
          setQueryData(parsedQueryData)
        }

        if (accessToken && !parsedQueryData) {
          if (redirectTo) {
            router.replace(redirectTo)
          } else {
            router.replace(`${getAppRoute(application, 'url')}/events`)
          }
        }

        setIsLoading(false)
      }

      clientSideInit()
    }, [router.isReady, router.query])

    if (isLoading) return null

    return <Component {...props} queryData={queryData} />
  }

  Wrapper.propTypes = {
    application: PropTypes.string,
    queryData: PropTypes.any,
    router: PropTypes.object,
  }

  return Wrapper
}

export default withSignUp(SignUpHOC(SignUp))
